import { useSelector } from 'react-redux';

import { workspacesSelector } from '@futrli/shared-services';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

import { StoreState } from '../../../../../../core/types';

export const useWorkspacesSelector = () => {
  const { workspaces } = useSelector((state: StoreState) => {
    const { normalised } = state;

    return {
      workspaces: workspacesSelector(normalised) as WorkspacesListingItem[]
    };
  });

  return workspaces;
};
